/**
 * created by li si yi
 * 约稿编辑器
 */
import React, {Component} from 'react';
import StoryEditor from "../storyEditor/StoryEditor";
import {message, Modal} from 'antd'
import EditorPublishInformation from "../components/EditorPublishInformation";
import {publishInformationConfig} from "./publish/publishInformation-config";
import {getInfoFromLocalStorage} from "../../../actions";
const storyStatus = {
    "投稿成功成功": "投稿成功"
};
export default class ReservationEditor extends StoryEditor {

    initParentData() {
        super.initParentData();
        // 约稿暂存更新约稿管理任务状态方法，只在暂存时调用
        window.ueditor.addAfterSaveDataFun(async (activiti, res, call) => {
            // console.log("=======1=========", activiti, "=======2=========", res, "=======3=========", call);
            let params = {
                "version": '-1',
                "storyId": res.id,// 稿件id
                requireContent: this.urlParams.requireContent,
                appointmentCreater: this.urlParams.appointmentCreater,
                "writeDate": "currentTime",
            };
            return new Promise((resolve, reject) => {
                this.request({
                    url: `/cm-sites-business/bd/${this.urlParams.businessName}/update/${this.urlParams.businessId}`,
                    method: 'POST',
                    body: params,
                    loading:false,
                    contentType: 'json',
                    callBack: (res1) => {
                        if (res1) {
                            resolve();
                        } else {
                            reject();
                            message.error('约稿失败！');
                            call && call(false);
                        }
                    },
                })
            })
        });
    }

    // 约稿稿件提交，更新约稿任务状态
    publishAppointment(activiti, param, call) {
        let params = {
            "version": '-1',
            "storyId": this.state.id,// 稿件id
            requireContent: this.urlParams.requireContent,
            appointmentCreater: this.urlParams.appointmentCreater,
            "writeDate": "currentTime",
            "status": this.urlParams.status,
        };
        this.request({
            url: `/cm-sites-business/bd/${this.urlParams.businessName}/update/${this.urlParams.businessId}`,
            body: params,
            method: 'POST',
            loading:false,
            contentType: 'json',
            callBack: (res) => {
                window.loading.hide();
                if (res) {
                    call && call.call(activiti,{code: 1, log: "约稿发布成功！"});
                } else {
                    message.error('约稿状态更新失败！');
                    // call && call(false);
                }
            },
        })
    }

    // 渲染稿件编辑器
    render() {
        return super.render();
    }

    pojoName = 'ygrwgj';

    /**设置流程配置*/
    initActivitiConfig(story) {
        let id = (this.props.id && this.props.id.length > 1 && this.props.id != 'null' && this.props.id != 'undefined') ? this.props.id : '';
        let that = this;
        let account = (window.currentUser && window.currentUser.account) ? window.currentUser.account : "";
        let userId = (window.currentUser && window.currentUser.id) ? window.currentUser.id : "";

        // 判断操作权限start
        let showBtnFlag = false;
        let mediaId = story && story.mediaId ? story.mediaId : "";
        if (mediaId) {
            let menu = getInfoFromLocalStorage("menu");
            let publishMenu = menu.find(item => item.menuCode == "mediaPublish");
            if (publishMenu && publishMenu.child && publishMenu.child.length) {
                if (publishMenu.child.find(item => item.menuCode == mediaId)) {
                    showBtnFlag = true;
                }
            }
        } else {
            showBtnFlag = true;
        }
        let pojoName = this.pojoName || 'tggj';
        // if(this.urlParams && this.urlParams.activitiConfName && this.urlParams.activitiConfName.indexOf("sczxwxlc")>-1) {
        //     pojoName = 'likeWechat'
        // }
        let activitiConf = this.urlParams ? {type: this.urlParams.activitiConfName} : null;
        let againFlag = false;
        // 如果草稿稿件可以被创建人之外的人看到，则需要手动控制审核流不要重启
        if(story && story.statusName === "草稿" && story.submitter !== userId) {
            // 当稿件状态为草稿时，审核流会自动重启，此时将activitiConf置空则审核流不重启
            activitiConf = null
        }
        // 判断操作权限end
        this.state.activityOption = {
            ...this.state.activityOption,
            id: id,//流程id
            activitiConf,//流程conf
            pojoName: pojoName,//数据表name
            userAccount: account,//当前用户account
            showBtnFlag,//是否显示流程按钮
            againFlag,//重置流程的判断条件
            showAfterFuns: {},//流程按钮加载前置js
            getTextRequisite: false,//备注是否必填
            closeServiceTemp: [
                function clearAfterEndFunction(activiti,param,call){

                    that.afterEndFunction = [];
                    call({code:1})
                },
            ],
            otherJs: {
                /**
                 * 新闻投稿提交至媒体前置js，判断是否有流程推进备选人
                 * @param activiti
                 * @param buttonConf
                 * @param call
                 */
                preCheckCandidate: (activiti, buttonConf, call) => {
                    let publishData = that.getPublish();
                    // let publishData = that.getPublishDetails();
                    let {synchronousContribute = []} = publishData;
                    // 推进流程的时候，投递栏目必填
                    if (!(synchronousContribute && synchronousContribute.length)) {
                        window.loading.hide();
                        message.destroy();
                        return message.warning("未选择投递媒体或部门")
                    }
                    let getErrorFun= ()=>{
                        message.destroy();
                        message.warning("未查到媒体候选人！");
                        window.loading.hide();
                    };
                    that.request({
                        url: "/cm-sites-pms/contribute/getAccessUser",
                        method: "post",
                        loading:false,
                        body: {mediaIds: synchronousContribute},
                        callBack: (res) => {
                            if(res && res.length) {
                                // call({code: 1, log: "查询到了媒体管理员"})
                                this.request({
                                    url:'/cm-sites-sys/user/getUserByPermissionsGroupByDept',
                                    method:'post',
                                    loading:false,
                                    body: {
                                        permissionCodes: ["received_story"],
                                        start:1,
                                        size:1000
                                    },
                                    contentType:"json",
                                    callBack:(data)=>{
                                        if (data && data.data.length) {
                                            let getUserByPermissions = res.some(item1 => data && data.data.some(item2 => item1.deptId === item2.deptRoles.deptId && item1.userId === item2._id))
                                            if (getUserByPermissions) {
                                                call({code: 1, log: "查询到了媒体候选人！"})
                                            } else {
                                                getErrorFun()
                                            }
                                        } else {
                                            getErrorFun()
                                        }
                                    }
                                })
                            } else {
                                getErrorFun()
                            }
                        },
                        errorCallBack: (e) => {
                            getErrorFun()
                        },
                    })
                },
                callActRevert: (activiti, buttonConf, call) => {
                    activiti.terminate.call(activiti, (res) => {
                        if (res) {
                            activiti.options.statusNameTemp = "草稿";
                            activiti.endFunction(activiti, function (res) {
                                if (res.status) {
                                    activiti.successMsg("流程已撤回，稿件变为草稿状态", function () {
                                        activiti.submitOK.call(activiti);
                                    });
                                }
                            })
                        }
                    });
                },
                /**
                 * 约稿稿件提交，更新约稿管理任务状态前置JS
                 */
                updateAppointmentStatus: (activiti, buttonConf, call) => {
                    that.afterEndFunction.push(that.publishAppointment.bind(that));
                    call({code:1,log: ''})
                }
            },//流程按钮点击事件前置js
            saveFunction: that.saveStory,//稿件保存方法
            saveStatusNameFunction: (statusName, activiti, call)=>{
                activiti.util.executeFunctionChain(that.afterEndFunction,activiti,{},function(){
                    that.updateStatusName(statusName, activiti, call);
                })
            },//稿件改流程状态方法
            onSubmitOK: function (activiti) {
                that.refresh(activiti)
            },//流程事件运行完毕的回调
            successCall: () => {
            },//流程加载完的回调
            readyCall: () => {
            },//流程初始化完的回调
            showRemarks: (remarks) => {
                if(remarks && remarks.length) {
                    this.setState({showRemarks:true,remarks})
                }
            },//备注回显
            onlyShowBtn: true,//是否只返回流程按钮
            title: '',//流程弹窗title
            visible: false,//流程弹窗是否展示
            mustNotShowPublishBtn: true, // 投稿编辑器中永远不显示发布按钮
            btnLoadOver: (btns) => {
                this.activitiBtns = btns;
                this.setState({});
            },
            showBtnIcon: true,
            showLockCall: (data) => {
                // data={status: true, id: this.messageId}  true 加锁成功，只有当前人可编辑，  false 加锁失败，不可编辑，
                // 如果加锁失败，则开启遮罩
                if (!data.status) {
                    this.Editor.showLockMask(data);
                    this.state.isLockedData = data;
                    this.setState({})
                }
            },
            btnType: "editor",
            checkForm: that.checkForm,
            successMsg: function (res,duration,call) {
                let msg = res;
                if(res.msg) {
                    msg = res.msg;
                }
                if(msg&&storyStatus[msg]) {
                    msg = storyStatus[msg];
                }
                message.success(msg, 1, call);
            }
        };
        this.setState({});
    }

    //获取基本信息
    getCurrentInformation() {
        let information = this.EditorInformation.getInformation();
        if (information && typeof information === "object") {
            return {
                ...information,
                category: "manuscripts"
            }
        } else {
            return information
        }
    }

    // 渲染稿件栏目模块
    renderEditorPublishInformation = () => {
        return (
            <EditorPublishInformation
                ref={(ref) => {
                    this.editorPublishInformation = ref
                }}
                isLine={'noLine'}
                title={'目标媒体'}
                informationConfig={publishInformationConfig}
            />
        )
    };

    getPublish = (data) => {
        let editorPublishInformation = this.editorPublishInformation.getData(data);
        if (editorPublishInformation && typeof editorPublishInformation === "object") {
            // 重置投稿时所选的媒体 arr[mediaId,...]
            editorPublishInformation["synchronousContribute"] = editorPublishInformation["ygMedia"];
        }
        return editorPublishInformation
    };

    getPublishDetails = (data) => {
        let editorPublishInformation = this.editorPublishInformation.getDetails(data);
        if (editorPublishInformation && typeof editorPublishInformation === "object") {
            // 重置投稿时所选的媒体 arr[mediaId,...]
            editorPublishInformation["synchronousContribute"] = editorPublishInformation["ygMedia"];
        }
        return editorPublishInformation
    };
}